import 'angular';
import 'angular-resource';
import routesModule from '../../../utilities/routes_module';

const dependencies = ['ngResource'];

angular
  .module('fundingSearchApp.models.trackedReport', dependencies)
  .factory('TrackedReport', [
    '$resource',
    $resource => {
      return $resource(routesModule.api_current_user_tracked_reports_path(),
        {
          report_id: '@report_id',
          report_type: '@report_type',
          name: '@name'
        }
      );
    }
  ]);
